const checkFloat = (value) =>{
    let parsed = Number.parseFloat(value);
    return (!Number.isNaN(parsed)) && (!Number.isInteger(parsed))
}

export default checkFloat;